// extracted by css-extract-rspack-plugin
export default {"cls1":"Filter-cls1_l6u","cls2":"Filter-cls2_PUq Filter-cls1_l6u","isDisabled":"Filter-isDisabled_rg7"};